import React from 'react';
import type { ReputationGeneratedTemplate } from '@reach/shared-types/automation-template';
import { MessageProgressRow } from './MessageProgressRow';
import styles from './reputation-defaults-dialog.module.css';

interface TemplateProgressGroupProps {
  template: ReputationGeneratedTemplate;
}

export const TemplateProgressGroup: React.FC<TemplateProgressGroupProps> = ({ template }) => (
  <li className={styles.templateProgress}>
    <h5 className={styles.templateProgressName}>{template.displayName}</h5>
    <ul className={styles.messageList}>
      {template.messages.map(message => (
        <MessageProgressRow key={message.actionIndex} message={message} />
      ))}
    </ul>
  </li>
);
